import Image from 'next/image';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import AppContext from '../../store/AppContext';
import PopupMap from "../PopupMap";

const FooterComponent = () => {

    const { branchs } = useContext(AppContext);

    const [selectAddress, setSelectAddress] = useState(0);
    const [selectBranch, setSelectBranch]:any = useState(null);
    const [isOpenMap, setIsOpenMap]:any = useState({
        isOpen: false,
        embed: ""
    });

    useEffect(() => {
        setSelectBranch(branchs?.find((item: any, index: number) => index === selectAddress));
    }, [branchs, selectAddress])


    return (
        <footer className='footer-component w-full'>
            <div className='footer-upper flex'>
                <div className=' footer_content_layout gap-[40px]  lg:gap-4'>
                    <div className='flex flex-col wrap-content mr-12'>
                        <h2 className='text-[20px] leading-[24px] text-[#434343] font-[500] mb-[1.5rem]'>Về Hoài Giang Shop</h2>
                        <span className='second-title mb-4'>Sản phẩm mới</span>
                        <span className='second-title mb-4'>Sản phẩm bán chạy</span>
                        <span className='second-title mb-4'>Được thuê nhiều nhất</span>
                        <span className='second-title mb-4'>Mẹo thời trang</span>
                        <span className='second-title'>Blog thời trang</span>
                    </div>
                    <div className='flex flex-col wrap-content mr-12'>
                        <h2 className='text-[20px] leading-[24px] text-[#434343] font-[500] mb-[1.5rem]'>
                            <Link
                                target='_blank' rel="noopener noreferrer"
                                href={'/chinh-sach-va-quy-dinh.html'}
                                className='hover:text-[#12C2C2] cursor-pointer'>CHÍNH SÁCH VÀ QUY ĐỊNH</Link>
                        </h2>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            href={'/chinh-sach-thanh-toan.html'}
                            className='text-center md:text-left second-title mb-4'>Chính sách thanh toán</Link>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            href={'/chinh-sach-van-chuyen-va-giao-nhan.html'}
                            className='text-center md:text-left second-title mb-4'>Chính sách vận chuyển</Link>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            href={'/chinh-sach-bao-mat-thong-tin.html'}
                            className='text-center md:text-left second-title mb-4'>Chính sách bảo mật thông tin</Link>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            href={'/chinh-sach-kiem-hang.html'}
                            className='text-center md:text-left second-title mb-4'>Chính sách kiểm hàng</Link>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            href={'/chinh-sach-doi-tra-va-hoan-tien.html'}
                            className='text-center md:text-left second-title mb-4'>Chính sách đổi trả hoàn tiền</Link>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            href={'/thong-tin-ve-gia-san-pham.html'}
                            className='text-center md:text-left second-title mb-4'>Thông tin về giá sản phẩm</Link>
                    </div>
                    <div className='relative bg-white '>
                        {/* Tạm ẩn */}
                        <div className="notes-branch">LƯU Ý: Thời gian làm việc các chi nhánh khác nhau. Quý khách vui lòng xem kỹ</div>
                        <div className="mt-3">
                            <div className={`
                                z-[1] 
                                flex flex-row gap-[2px]
                                top-[-36px] 
                                left-[8px] 
                                cursor-pointer
                            `}>
                                {branchs?.map((item: any, index: number) => {
                                    return <span
                                        title={item?.name}
                                        key={item.id}
                                        onClick={() => setSelectAddress(index)}
                                        className={`
                            ${selectAddress === index ? "ft_tab_active" : "ft_tab text-[#686868] max-w-[100px] xl:max-w-[300px]"}
                        `}>
                                        {item?.name}
                                    </span>
                                })}
                            </div>
                            <div className='text-[#434343] relative w-full min-h-[168px] bg-white w-auto lg:w-[450px] xl:w-[560px] pt-4 px-4 pb-[1.5rem] flex flex-col footer_address z-[3]'>
                                <div className='text-sm font-bold text-[#434343] mb-[12px] inline'>Địa chỉ:
                                    <p className='ml-1 text-sm font-[400] inline'>
                                        {selectBranch?.address ?? ""}
                                    </p>
                                </div>
                                <div className='text-sm font-bold mb-[12px] inline'>
                                    Sđt: {selectBranch?.phone && <p className='text-sm font-[400] text-[#434343] inline'>{selectBranch?.phone.join(" - ")}</p>}
                                </div>
                                <div className='text-sm font-bold mb-[24px] inline'>
                                    Thời gian làm việc:
                                    <p className='ml-1 text-sm font-[400] text-[#e03616] inline'>
                                        {selectBranch?.description ?? ""}
                                    </p>
                                </div>
                                <div className='flex flex-row gap-[1.5rem]'>
                                    <a href={selectBranch?.facebook ?? ""} target='_blank' rel="noreferrer">
                                        <Image
                                            src={"/asset/icon/ico_ft_fb.svg"}
                                            alt={"facebook"}
                                            width={32}
                                            height={32}
                                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                    </a>
                                    <a href={"https://zalo.me/"+selectBranch?.phone[0] ?? ""} target='_blank' rel="noreferrer">
                                        <Image
                                            src={"/asset/icon/ico_ft_zalo.svg"}
                                            alt={"zalo"}
                                            width={32}
                                            height={32}
                                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                    </a>
                                    <Image
                                        onClick={() => {
                                            setIsOpenMap({
                                                isOpen: true,
                                                embed: selectBranch?.address_src
                                            })
                                        }}
                                        src={"/asset/icon/ico_ft_ggmap.svg"}
                                        alt={"map"}
                                        width={32}
                                        height={32}
                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <div className='flex my-auto relative'>
                        <div className='footer-social--icons'>
                            <div className='footer-social--icons--item'>
                                <Image
                                    src="/asset/icon/ico_facebook.png"
                                    alt="facebook"
                                    width={24}
                                    height={24}
                                />
                            </div>

                            <div className='footer-social--icons--item footer-social--icons--item--active'>
                                <Image
                                    src="/asset/icon/ico_zalo.svg"
                                    alt="zalo"
                                    width={24}
                                    height={24}
                                />
                            </div>
                        </div>
                        <div className='my-4 wrap_footer-social'>
                            <div className='w-full flex-1 h-full footer-social'>
                                <div className='flex w-42 flex-col px-1 py-8 gap-2'>
                                    <span className='heading'>Chi nhánh Q-Bình Tân</span>
                                    <Image
                                        src="/asset/image/Mask-group-2.png"
                                        alt="face"
                                        width={184}
                                        height={87}
                                    />
                                </div>
                                <div className='flex w-42 flex-col px-1 py-8 gap-2'>
                                    <span className='heading'>Chi nhánh Q5</span>
                                    <Image
                                        src="/asset/image/Mask-group-2.png"
                                        alt="face"
                                        width={184}
                                        height={87}
                                    />
                                </div>
                                <div className='flex w-42 flex-col px-1 py-8 gap-2'>
                                    <span className='heading'>Chi nhánh Q6</span>
                                    <Image
                                        src="/asset/image/Mask-group-2.png"
                                        alt="face"
                                        width={184}
                                        height={87}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='my-auto flex justify-center items-center md:w-[447px] md:h-[242px] xl:w-[447px] xl:h-[242px]'>
                        <Image
                            className='cursor-pointer'
                            src="/asset/image/footer_address.svg"
                            alt="address"
                            width={447}
                            height={242}
                        />
                    </div> */}
                </div>
            </div>
            <div className='wrap-title'>
                <div className='divider'></div>
                <Image
                    src="/asset/icon/logo_footer.webp"
                    alt="Logo shop"
                    width={221}
                    height={48}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
                <div className='divider'></div>
            </div>
            <div className="w-full border-gray-200 pt-4 pb-8">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex flex-col items-center gap-1 text-center text-gray-500 text-xs md:text-sm">
                        <p className="font-semibold text-gray-600">
                            CÔNG TY TNHH PICAT
                        </p>
                        <p className="font-medium text-gray-600">
                            GPKD số 0314333426 do Sở KH và ĐT TP Hồ Chí Minh cấp ngày 05/04/2017
                        </p>
                        <p className="font-medium text-gray-600">
                            Địa chỉ: 532/28/34/19 đường Khu Y Tế Kỹ Thuật Cao, Phường An Lạc,
                            TP Hồ Chí Minh, Việt Nam
                        </p>
                        <a target="_blank" rel="nofollow noopener noreferrer" href="http://online.gov.vn/Home/WebDetails/141380">
                            <Image src="/asset/image/bct.webp"
                                    alt="Logo BCT"
                                    width={120}
                                    height={45}
                                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"/>
                        </a>
                    </div>
                </div>
            </div>
            {
                isOpenMap && isOpenMap.isOpen && <PopupMap isOpen={isOpenMap.isOpen} 
                embed={isOpenMap.embed}
                setIsOpen={(agr:any) => {
                    setIsOpenMap(agr)
                }} />
            }
        </footer>
    )
}

export default FooterComponent